<template>
  <div class="scenarios-container">
    <div v-for="scenario in scenarios" class="scenario-item" :key="scenario.id">
      <p class="scenario-item__title">{{ scenario.title }}</p>
      <p class="scenario-item__description">{{ scenario.description }}</p>
      <img class="scenario-item__image" :src="scenario.image" alt="">
      <button class="scenario-item__button" data-toggle="modal" :data-target="`#${scenario.modalId}`"
        data-gtm-section="Why Digital" data-gtm-subsection="Manufacturing Benefits"
        :data-gtm-label="`Click ${scenario.title}`">{{ scenario.cta_label }}</button>
      <Modal :idModal="scenario.modalId">
        <h2 class="modal-title">{{ scenario.title }}</h2>
        <component :is="scenario.component" />
      </Modal>
    </div>
  </div>

</template>

<script>
import Modal from '@/components/modal/Modal.vue';
import ScenarioOne from './scenarios/ScenarioOne.vue';
import ScenarioTwo from './scenarios/ScenarioTwo.vue';

export default {
  name: 'Scenarios',
  components: {
    Modal,
    ScenarioOne,
    ScenarioTwo,
  },
  data() {
    return {
      scenarios: [
        {
          id: 1,
          title: 'Scenario 1',
          description: 'Single SKU',
          image: 'images/why-digital/manufacturing-benefits/scenario_1_manufacturing_benefits.png',
          cta_label: 'Learn More',
          modalId: 'scenario-1',
          component: 'ScenarioOne',
        },
        {
          id: 2,
          title: 'Scenario 2',
          description: 'Multiple SKU with Batch Printing',
          image: 'images/why-digital/manufacturing-benefits/scenario_2_manufacturing_benefits.png',
          cta_label: 'Learn More',
          modalId: 'scenario-2',
          component: 'ScenarioTwo',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/_mixins.scss';

.scenarios-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .scenario-item {
    text-align: center;
    font-family: $font_default;
    margin-top: 70px;

    &__title {
      color: $color_blue_light_two;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.028px;
      text-transform: uppercase;
    }

    &__description {
      margin-top: 7px;
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
      letter-spacing: -0.028px;
    }

    &__image {
      height: 220px;
      margin-top: 46px;
      margin-bottom: 46px;
    }

    &__button {
      width: 195px;
      height: 48px;
      background-color: $color_blue_light;
      color: $color_white;
      font-size: 21.663px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.041px;
      text-transform: uppercase;
      border: none;
      filter: drop-shadow(0 4.814px 4.814px rgba(0, 0, 0, 0.25));
    }
  }
}
</style>
